export default __webpack_public_path__ + "static/ildebote-5a110c1dab0a9c625122e23f67ab566a.png";